<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >

                    <section class="modal-card-body  "  >
                        <b-taglist v-if="OPDSelected">


                              <b-tag type="is-info" size="is-large">  {{ OPDSelected.idopd }}</b-tag>



                              <b-tag type="is-info" size="is-large">  {{ OPDSelected.opdname }}</b-tag>



                               <b-tag type="is-info" size="is-large">  {{ OPDSelected.owner_name }}</b-tag>

                        </b-taglist>
<!--                          <b-field grouped group-multiline v-if="OPDSelected">-->

<!--                              <span class="tag is-info" size="is-medium"  >-->
<!--                                 {{ OPDSelected.idopd }}-->
<!--                              </span>-->
<!--                              &nbsp;-->
<!--                              <span class="tag is-info"  >-->
<!--                                 {{ OPDSelected.opdname }}-->
<!--                              </span>-->
<!--                              &nbsp;-->
<!--                              <span class="tag is-info"  >-->
<!--                                 {{ OPDSelected.owner_name }}-->
<!--                              </span>-->

<!--                        </b-field>-->

                        <hr>

                        <b-field grouped label="" on-border>
                           &nbsp;<b-field label="Select Visit">
                                <b-select placeholder="Select a Visit/Walkin" v-model="refnoSelected">
                                    <option
                                            v-for="datRefNo in datRefNos"
                                            :value="datRefNo.ref_no"
                                            :key="datRefNo.ref_no" >
                                        from      <span class="tag is-success">  {{ customFormatDate (datRefNo.date_walkin) }}  {{ datRefNo.time_walkin }} </span> to {{ customFormatDate(datRefNo.date_finish) }}  {{ datRefNo.time_finish }}
                                        ({{datRefNo.ref_no}})
                                    </option>
                                </b-select>
                            </b-field>

                           <b-field  label="Search" >
                            <p class="control">
                                <b-button class="button is-primary" @click="getHistoryFinanceOfVisit" >Search</b-button>
                            </p>
                            </b-field>
                            &nbsp;
                            <b-field  label="Total" v-if="datHistoryFinance.length>0">
                                <b-tag type="is-info" size="is-large">{{formatAmount(SumTotal)}}</b-tag>
                            </b-field>

                            <b-field  label="Enable" v-if="datHistoryFinance.length>0 && SumTotalDisable>0">
                                <b-tag type="is-success" size="is-large">{{formatAmount(SumTotalEnable)}}</b-tag>
                            </b-field>

                            <b-field  label="Disable" v-if="datHistoryFinance.length>0 && SumTotalDisable>0">
                                <b-tag type="is-danger" size="is-large">{{formatAmount(SumTotalDisable)}}</b-tag>
                            </b-field>



                        </b-field>



                    </section>

                </header>
                <section class="modal-card-body"  >
                    <!-- Content ... -->
                    <b-loading  :active.sync="isFullScreenSearching" ></b-loading>


<!--                    <b-table :data="datHistoryFinance" :columns="columns"></b-table>-->
                    <b-table
                            :data="datHistoryFinance"
                            :loading="isLoading"
                             >



                            <b-table-column field="type" label="No" v-slot="props">
                                {{ props.row.no }}
                            </b-table-column>


                            <b-table-column field="type" label="Type" v-slot="props" >
                                {{ props.row.type }}
                            </b-table-column>

                            <b-table-column field="idpart" label="ID" v-slot="props">
                                {{ props.row.idpart }}
                            </b-table-column>

                            <b-table-column field="last_name" label="Description" v-slot="props">
                                {{ props.row.descp }}
                            </b-table-column>

                            <b-table-column field="last_name" label="Amount" v-slot="props">
                                {{ formatAmount(props.row.amount) }}
                            </b-table-column>

                            <b-table-column field="last_name" label="Unit" v-slot="props">
                                {{ props.row.unit }}
                            </b-table-column>

                            <b-table-column field="last_name" label="Price" v-slot="props">
                                {{formatAmount(props.row.price)}}
                            </b-table-column>

                            <b-table-column field="status" label="status" v-slot="props">
<!--                                <b-icon pack="fas"-->
<!--                                        :icon="props.row.status === 'D' ? 'minus-circle' :  'check' ">-->
<!--                                </b-icon>-->
<!--                                <span class="tag is-danger" v-if="props.row.status === 'D'" >-->
<!--                                    Disable-->
<!--                                </span>-->

                                <b-button type="is-danger" size="is-small" v-if="props.row.status === 'D'"  @click="showInfoDisable( props.row.id )">Disable</b-button>

                                <span class="tag is-success" v-if="props.row.status === 'E'" >
                                    Enable
                                </span>

                            </b-table-column>

                            <b-table-column field="daterec" label="date rec" v-slot="props">
                                {{ customFormatDate(props.row.daterec)  }}
                            </b-table-column>


                            <b-table-column field="timerec" label="time rec" v-slot="props">
                                {{ props.row.timerec  }}
                            </b-table-column>


                            <b-table-column field="userrec" label="user rec" v-slot="props">
                                {{ props.row.userrec  }}
                            </b-table-column>





<!--                        <template slot="empty">-->
<!--                            <section class="section">-->
<!--                                <div class="content has-text-grey has-text-centered">-->
<!--                                    <p>-->
<!--                                        <b-icon-->
<!--                                                icon="emoticon-sad"-->
<!--                                                size="is-large">-->
<!--                                        </b-icon>-->
<!--                                    </p>-->
<!--                                    <p>Nothing here.</p>-->
<!--                                </div>-->
<!--                            </section>-->
<!--                        </template>-->


<!--                        <template slot="footer" >-->
<!--                            <th class="is-hidden-mobile" style="width:40px">-->

<!--                            </th>-->
<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->
<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->
<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->
<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->
<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->

<!--                            <th class="is-hidden-mobile">-->
<!--                                <div class="th-wrap">  <span class="tag is-info"> {{formatAmount(SumTotal)}} </span> </div>-->
<!--                            </th>-->

<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->

<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->

<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->

<!--                            <th class="is-hidden-mobile">-->

<!--                            </th>-->

<!--                        </template>-->


                    </b-table>





                   <DlgInfoHistoryDisable v-if="isModalDlgInfoHistoryDisable" @close="closeDlgInfoHistoryDisable" :dataToChild="infoDisable"/>

                </section>
                <footer class="modal-card-foot">

                    <b-button type="is-danger"
                              icon-left="close"  @click="closeModal"   >
                        Close
                    </b-button>


                </footer>
            </div>

        </b-modal>


    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import { getBaseURLforBackEnd , getConfigAxios ,fixedNumber ,customFormatDate , checkAccessTokenWithFpValid}  from '@/utils.js'
    import {mapState} from "vuex";
    import DlgInfoHistoryDisable from "./DlgInfoHistoryDisable";

    export default {
        name: "HistoryFinance",
        components:{
            DlgInfoHistoryDisable
        },
        computed: {
            ...mapState({
                OPDSelected: state => state.opd_target.opd_selected,
                user_id: state => state.master_data.user_id,
                clientIP: state => state.master_data.clientIP,
                fingerPrint : state => state.master_data.fingerPrint,
                access_token: state => state.master_data.access_token,
            }),
            SumTotal: function () {
                const point =   this.datHistoryFinance.map(dat=>{
                        return dat.price
                })
               return point.reduce((acc,cur)=>acc+cur , 0)

            },
            SumTotalEnable: function () {
                const point =   this.datHistoryFinance.map(dat=>{
                    return  dat.status==='E' ? dat.price : 0
                })
                return point.reduce((acc,cur)=>acc+cur , 0)

            },
            SumTotalDisable: function () {
                const point =   this.datHistoryFinance.map(dat=>{
                    return  dat.status==='D' ? dat.price : 0
                })
                return point.reduce((acc,cur)=>acc+cur , 0)

            }
        },
        methods:{
            showInfoDisable(id){
                this.infoDisable = this.datHistoryFinance.find(dat=>{
                    return  dat.id === id
                })

                this.isModalDlgInfoHistoryDisable = true
            },
            closeDlgInfoHistoryDisable(){
                this.isModalDlgInfoHistoryDisable = false
            },
             formatAmount(num){
              return fixedNumber(num,2)
            },
            customFormatDate(data){
               return  customFormatDate(data)
            },
            getHistoryFinanceOfVisit(){

                const vm  = this
                checkAccessTokenWithFpValid(this.fingerPrint)
                    .catch(()=>{
                        vm.$router.push('/login')
                    })


                if (this.refnoSelected) {
                    const dat =     {
                        "ref_no": this.refnoSelected
                    }
                    // console.log(dat)
                    const vm = this
                    this.isLoading = true
                    this.isFullScreenSearching = true
                    axios.post(`${getBaseURLforBackEnd()}/api/historyfinance_of_visit`,dat,getConfigAxios())
                        .then((res)=>{
                            vm.datHistoryFinance = res.data
                            vm.isLoading = false
                            vm.isFullScreenSearching = false
                            // console.log(vm.datHistoryFinance)
                        })
                        .catch( function(err) {
                            if (err.response && err.response.status === 401) {
                                vm.isFullScreenSearching = false
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=> {
                            vm.isLoading = false
                            vm.isFullScreenSearching = false
                            }
                        )
                }
            },
            closeModal(){
                this.isComponentModalActive = false
                // console.log('close')
            },
             loadVisitWalkin(){

                 // if (!checkAccessTokenWithFpValid(this.fingerPrint)){
                 //     this.$router.push('/login')
                 //     return
                 // }

                 const vm  = this
                 checkAccessTokenWithFpValid(this.fingerPrint)
                 .catch(()=>{
                     vm.$router.push('/login')
                 })

                if(this.user_id){
                        const dat =     {
                            "idopd": this.OPDSelected.idopd ,
                            "user": this.user_id,
                            "ip": this.clientIP
                        }
                        // console.log(dat)
                        const vm = this
                        this.isFullScreenSearching = true

                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}/api/list_of_visit`,dat,getConfigAxios())
                            .then((res)=>{
                                vm.datRefNos = res.data
                                vm.isFullScreenSearching = false
                            })
                            .catch( function(err) {
                                if (err.response && err.response.status === 401) {
                                    vm.$router.push('/login')
                                }
                            })
                            .finally(
                                vm.isFullScreenSearching = false
                            )
                }else{
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }

            }

        },

        data(){
            return{

                isComponentModalActive : false,
                isFullScreen : true,
                isFullScreenSearching : false,
                datRefNos : null,
                refnoSelected : null ,
                datHistoryFinance : [],
                isEmpty : false,
                isModalDlgInfoHistoryDisable: false ,
                infoDisable : null,
                isLoading: false

            }
        }
    }
</script>

<style scoped>

</style>